if($(".image-highlight-with-copy")) {

    $('.image-highlight-with-copy').each(function() {

        let imageContainer = $(this).find('.image-container'),
            containerWidth = $(this).find('.container').width();

        let offsetWidth = ($(window).width() - containerWidth) / 2;

        imageContainer.css('margin-right', 0 - offsetWidth);

    });

}
